var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "config-ctn"
  }, [_vm.isLoadingATPConfig ? _c('div') : _c('div', [_c('h4', {
    staticClass: "text-capitalize font-weight-bold title"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_config')))]), _c('div', {
    staticClass: "mt-10"
  }, [_vm.isATPEnabled ? _c('div', [_c('div', {
    staticClass: "flex align-center"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "size": "22",
      "color": "#3FC135"
    }
  }, [_vm._v("mdi-check-circle")]), _c('span', [_vm._v(_vm._s(_vm.$t('amazon_transparency_is_enabled')))])], 1), _c('div', {
    staticClass: "d-flex flex-column ml-8"
  }, [_c('div', {
    staticClass: "flex align-center mt-5 mt-md-10"
  }, [_c('span', {
    staticClass: "font-weight-bold mr-6 label-text"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_tln_number')))]), _c('span', [_vm._v(_vm._s(_vm.accountId))])])])]) : _vm._e(), !_vm.isATPEnabled ? _c('div', [_c('p', {
    staticClass: "config-text"
  }, [_vm._v(" " + _vm._s(_vm.$t('amazon_transparency_not_enabled'))), _c('br'), _vm._v(" " + _vm._s(_vm.$t('amazon_transparency_setup_tasks')) + " ")]), _c('div', {
    staticClass: "mt-10"
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: _vm.isFormValid,
      callback: function ($$v) {
        _vm.isFormValid = $$v;
      },
      expression: "isFormValid"
    }
  }, [_c('v-label', {
    staticClass: "label-text"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_enter_tln_number')))]), _c('div', {
    staticClass: "flex align-center mt-1"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "small": "",
      "dense": "",
      "outlined": "",
      "counter": 13,
      "rules": _vm.tlnRules,
      "required": "",
      "disabled": _vm.disableFormFields,
      "placeholder": _vm.$t('amazon_transparency_tln_number')
    },
    model: {
      value: _vm.form.tln,
      callback: function ($$v) {
        _vm.$set(_vm.form, "tln", $$v);
      },
      expression: "form.tln"
    }
  })], 1), _c('v-col', {}, [_c('v-btn', {
    staticClass: "text-uppercase",
    attrs: {
      "color": "#15BBF0",
      "height": "40",
      "loading": _vm.isEnrolling,
      "disabled": !_vm.isFormValid || _vm.isEnrolling
    },
    on: {
      "click": _vm.enrollBtnClick
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('amazon_transparency_enroll')) + " ")])], 1)], 1)], 1)], 1)], 1)]) : _vm._e()])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }